__turbopack_context__.v({
  "active": "F-VYQq_active",
  "advanced": "F-VYQq_advanced",
  "backButton": "F-VYQq_backButton",
  "beginner": "F-VYQq_beginner",
  "challengeInfo": "F-VYQq_challengeInfo",
  "challengeMeta": "F-VYQq_challengeMeta",
  "challengeTitle": "F-VYQq_challengeTitle",
  "difficulty": "F-VYQq_difficulty",
  "header": "F-VYQq_header",
  "intermediate": "F-VYQq_intermediate",
  "item": "F-VYQq_item",
  "langTag": "F-VYQq_langTag",
  "languages": "F-VYQq_languages",
  "link": "F-VYQq_link",
  "list": "F-VYQq_list",
  "menu": "F-VYQq_menu",
  "separator": "F-VYQq_separator",
  "subtitle": "F-VYQq_subtitle",
  "time": "F-VYQq_time",
  "title": "F-VYQq_title",
  "titleLink": "F-VYQq_titleLink",
});
